import React from "react";
import { formatIsoDateForDisplay } from "@helpers/date";

interface ReconciliationRangeItem {
    openingDate: string;
    closingDate: string;
}

const formatRange = ({ openingDate, closingDate }: ReconciliationRangeItem) =>
    `${formatIsoDateForDisplay(openingDate)} to ${formatIsoDateForDisplay(closingDate)}`;

export const ReconciliationRanges: React.FC<{
    title: string;
    ranges: ReconciliationRangeItem[];
}> = ({ title, ranges }) => {
    if (ranges.length === 0) {
        return null;
    }
    return (
        <div className="mt-2">
            <p className="mb-0">
                <strong>{title}</strong> reconciled periods:
            </p>
            <ul className="mb-0">
                {ranges.map((range) => (
                    <li key={`${range.openingDate}-${range.closingDate}`}>
                        {formatRange(range)}
                    </li>
                ))}
            </ul>
        </div>
    );
};
